import classes from "./Filters.module.css";
import { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../../UI/Loader";
import { FaPlay, FaEraser } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const Filters = (props) => {
    const { t } = useTranslation();
    // 👉 Utility function to get today's date in YYYY-MM-DD format
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split("T")[0];
    };

    const [startDate, setStartDate] = useState(getTodayDate()); // default today
    const [endDate, setEndDate] = useState(getTodayDate()); // default today
    const [dateError, setDateError] = useState({ startDate: "", endDate: "" });
    const [loading, setLoading] = useState(false);

    // Validate both start and end date
    const validateDate = (start, end) => {
        let startError = "";
        let endError = "";

        if (!start) startError = t("Please select a start date");
        if (!end) endError = t("Please select an end date");

        if (start && end) {
            const diffDays =
                (new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24);
            if (diffDays < 0) endError = t("End date cannot be before start date");
            if (diffDays > 90)
                endError = t("Date range cannot exceed 90 days from start date");
        }

        return { startDate: startError, endDate: endError };
    };

    const onGetStartDateHandler = (e) => {
        const dateValue = e.target.value;
        setStartDate(dateValue);

        const errors = validateDate(dateValue, endDate);
        setDateError(errors);
    };

    const onGetEndDateHandler = (e) => {
        const dateValue = e.target.value;
        setEndDate(dateValue);

        const errors = validateDate(startDate, dateValue);
        setDateError(errors);

        if (errors.endDate) {
            toast.error(errors.endDate);
        }
    };

    const onGetStartAndEndDate = (e) => {
        e.preventDefault();

        const errors = validateDate(startDate, endDate);
        setDateError(errors);

        if (errors.startDate || errors.endDate) {
            if (errors.startDate) toast.error(errors.startDate);
            if (errors.endDate) toast.error(errors.endDate);
            return;
        }

        props.onGetStartAndEndDate(startDate, endDate); // 🔥 Only called on submit
    };

    const onClearFields = () => {
        setStartDate(getTodayDate());
        setEndDate(getTodayDate());
        setDateError({ startDate: "", endDate: "" });
    };

    return (
        <div className="bg-light p-3 rounded mx-0 shadow-sm border mt-3 mb-4">
            {loading && <Loader />}
            <form onSubmit={onGetStartAndEndDate}>
                <div className="row g-3 justify-content-start align-items-end">
                    <div className="col-md-auto col-6">
                        <label htmlFor="startDate" className="fw-bold small mb-1 text-muted d-block">
                            {t("Start Date:")}
                        </label>
                        <input
                            id="startDate"
                            type="date"
                            value={startDate}
                            onChange={onGetStartDateHandler}
                            className={`form-control form-control-sm ${dateError.startDate ? classes.invalid : ""}`}
                            style={{ border: "1px solid #ced4da", width: "100%" }}
                        />
                    </div>

                    <div className="col-md-auto col-6">
                        <label htmlFor="endDate" className="fw-bold small mb-1 text-muted d-block">
                            {t("End Date:")}
                        </label>
                        <input
                            id="endDate"
                            type="date"
                            key={endDate}
                            value={endDate}
                            onChange={onGetEndDateHandler}
                            min={startDate || ""}
                            className={`form-control form-control-sm ${dateError.endDate ? classes.invalid : ""}`}
                            style={{ border: "1px solid #ced4da", width: "100%" }}
                        />
                    </div>

                    <div className="col-md-auto col-12">
                        <div className="d-flex gap-2">
                            <button
                                type="submit"
                                className="btn-premium flex-grow-1"
                                disabled={dateError.startDate || dateError.endDate}
                            >
                                <FaPlay className="me-2" /> {t("SUBMIT")}
                            </button>
                            <button
                                type="button"
                                className="btn-secondary-premium flex-grow-1"
                                onClick={onClearFields}
                            >
                                <FaEraser className="me-2" /> {t("CLEAR")}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default Filters;
